import { analyticsTypes } from '../types';

import { extractPageName, prophetTypes } from '@/features/prophet';

export const isEmptyKeywords = (keywords: Record<string, number | string>) =>
  Object.keys(keywords).length === 0;

export const getCellValue = (
  row: analyticsTypes.RequestsTableRow,
  column: keyof analyticsTypes.RequestsTableRow
) => {
  if (column === 'date' && row[column]) {
    return row[column].replaceAll('/', '.');
  }
  const value = row[column];
  return value !== undefined && value !== null ? value : 'Unknown';
};

export const getTableData = (
  pagesData?: prophetTypes.Page[],
  report?: analyticsTypes.RequestsReport
) => {
  if (!pagesData || !report) {
    return [];
  }

  const pageNames: Record<string, string> = { total: 'TOTAL' };
  pagesData.forEach((page) => {
    if (!pageNames[page._id]) {
      pageNames[page._id] = extractPageName(page);
    }
  });

  return report.map((item) => ({
    ...item,
    pageName: pageNames[item.page._id],
  }));
};
